import axios from 'axios'
import {FilterModel} from '../../../../models/FilterModel'
import type {RoleModel, RoleModelCreateParams} from '../../../../models/RoleModel'
import {UserModel, UserModelCreateParams} from '../../../../models/UserModel'
import {ConfigGroupCreateParams, ConfigGroupModel} from '../../../../models/system/ConfigGroupModel'
import {GlobalSearchModel} from '../../../../models/GlobalSearchModel'
import {ConfigTypeModel} from '../../../../models/system/ConfigTypeModel'

const CRUD_ROLE = '/role'
const CRUD_USER = '/user'
const SYSTEM_ALL_ROLES = '/role/all'
const SYSTEM_ORGANIZATION = '/system/organization'
const SYSTEM_ORGANIZATION_LOG = '/system/log'
const SYSTEM_ROLES = '/role'
const SYSTEM_SEARCH_ROLES = '/role/list'
const SYSTEM_SEARCH_USERS = '/system/user/list'

export const DeleteOrganizationUser = (codes: string[]) => axios.delete(CRUD_USER, {data: {codes}})
export const DeleteOrganizationRole = (codes: string[]) =>
  axios.delete(SYSTEM_ROLES, {data: {codes}})
export const GetOrganizationAllRoles = () => axios.get<RoleModel[]>(SYSTEM_ALL_ROLES)
export const GetOrganizationLogs = (filter?: FilterModel) =>
  axios.post(SYSTEM_ORGANIZATION_LOG, filter)
export const GetOrganizationProfile = () => axios.get(SYSTEM_ORGANIZATION)
export const GetOrganizationRole = (filter?: FilterModel) => axios.post(SYSTEM_SEARCH_ROLES, filter)
export const GetOrganizationRoleByCode = (code: string) => axios.get(`${SYSTEM_ROLES}/${code}`)
export const GetOrganizationUsers = (filter?: FilterModel) =>
  axios.post(SYSTEM_SEARCH_USERS, filter)

export const PostRole = (data: RoleModelCreateParams) => axios.post(CRUD_ROLE, data)
export const PutRole = (data: RoleModelCreateParams, code: string) =>
  axios.put(`${CRUD_ROLE}/${code}`, data)

export const PostUser = (data: any) => axios.post(CRUD_USER, data)
export const GetUserByCode = (userCode: string) => axios.get<UserModel>(`${CRUD_USER}/${userCode}`)
export const PutUser = (data: UserModelCreateParams, code: string) =>
  axios.put(`${CRUD_USER}/${code}`, data)
export const ResetUserMFA = (userCodes: string[]) =>
  axios.post(`/user/reset-mfa`, {
    codes: userCodes,
  })

export const GetConfigGroupByCode = (code: string) =>
  axios.get<ConfigGroupModel>(`/config-group/${code}`)
export const SearchConfigGroups = (filters?: FilterModel) =>
  axios.post<GlobalSearchModel<ConfigGroupModel>>(`/config-group/list`, filters)
export const CreateConfigGroup = (params: ConfigGroupCreateParams) =>
  axios.post<ConfigGroupModel>(`/config-group`, params)
export const UpdateConfigGroup = (code: string, params: ConfigGroupCreateParams) =>
  axios.put<ConfigGroupModel>(`/config-group/${code}`, params)
export const DeleteConfigGroup = (codes: string[]) =>
  axios.delete(`/config-group`, {
    data: {
      codes,
    },
  })
export const ActivateConfigGroup = (code: string) => axios.post(`/config-group/activate/${code}`)

export const GetAllConfigTypes = () => axios.get<ConfigTypeModel[]>(`/type`)
export const GetConfigTypeByCode = (code: string) => axios.get<ConfigTypeModel>(`/type/${code}`)
